"use client";

import { useStoryblokState } from "@storyblok/react";
import PageBulletproof from "./page-bulletproof";
import BlogPageBulletproof from "./blog-page-bulletproof";
import BlogHomepageBulletproof from "./blog-homepage-bulletproof";
import BlogAuthorBulletproof from "./blog-author-bulletproof";
import { useBlogContext } from "@/contexts/BlogContext";
import { useEffect } from "react";

const Client = ({ story, allBlogPosts, authorPosts, trustSmall }: { story: any; allBlogPosts?: any[] | null; authorPosts?: any[] | null; trustSmall?: any[] | null }) => {
  const liveStory = useStoryblokState(story);
  const { updateBlogPosts } = useBlogContext();

  // Update blog posts in context when they become available
  useEffect(() => {
    if (Array.isArray(allBlogPosts) && allBlogPosts.length > 0) {
      updateBlogPosts(allBlogPosts);
    }
  }, [allBlogPosts, updateBlogPosts]);

  if (!liveStory?.content) {
    return <div>Error: Story content missing</div>;
  }

  const pageContent = liveStory.content as any;

  switch (pageContent.component) {
    case "page_bulletproof":
      return <PageBulletproof content={pageContent} trustSmall={trustSmall} />;
    case "blog_page_bulletproof":
      return <BlogPageBulletproof content={pageContent} />;
    case "blog_homepage_bulletproof":
      return <BlogHomepageBulletproof content={pageContent} allBlogPosts={allBlogPosts} />;
    case "blog_author":
      return <BlogAuthorBulletproof content={pageContent} authorPosts={authorPosts} />;
    default:
      return <div>Error: Invalid story component: {pageContent.component}</div>;
  }
};

export default Client;